/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Sort_Customers_DescInputs */



/**
* | output |
* | --- |
* | "customers, most first" |
*
* @param {Partner_Billing_Board_Sort_Customers_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_sort_customers_desc = /** @type {((inputs?: Partner_Billing_Board_Sort_Customers_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Sort_Customers_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kunden, meiste zuerst")
	return /** @type {LocalizedString} */ ("customers, most first")
});